/* @flow */

import * as React from 'react';
import classNames from 'classnames';
import TextArea from 'src/shared/ui/component/form/TextArea';

type Props = {
  className: string,
  field: Object,
  inputProps: Object,
  isHighlighted: boolean,
  isMinified: boolean,
  handleFocus: () => void,
  handleBlur: () => void,
  hasError?: boolean,
};

const FormikTextArea = ({
  className,
  field,
  inputProps,
  isHighlighted,
  isMinified,
  handleFocus,
  handleBlur,
  hasError,
}: Props): React.Node => {
  const rootClasses = classNames(
    className,
    field.className,
    inputProps.className,
  );

  return (
    <TextArea
      {...field}
      {...inputProps}
      className={rootClasses}
      isHighlighted={isHighlighted}
      isMinified={isMinified}
      hasError={hasError}
      onFocus={handleFocus}
      onBlur={(e) => {
        field.onBlur(e);

        handleBlur();
      }}
    />
  );
};

export default React.memo<Props>(FormikTextArea);
